<template>
  <table class="min-w-full leading-normal">
    <thead>
      <tr>
        <th
          class="pl-4 text-zt-xs border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-primary-200 font-normal tracking-wide"
        >
          <zt-check-box v-model="allSelected" @change="setDocumentSelected" class="zt-custom-checkbox" v-if="isActionAllowed(downloadActionId)" />
        </th>
        <th
          class="text-zt-xs pl-2 pr-6 py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        ></th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        >
         {{ $t('message.searchComponent.items.name') }} / {{ $t('message.userActive.cuil') }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        >
          {{ $t('message.searchComponent.items.docType') }} / {{ $t('message.searchComponent.items.period') }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        >
          {{ $t('message.searchComponent.items.sector') }} / {{ $t('message.searchComponent.items.location') }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        >
          {{ $t('message.searchComponent.items.status') }}
        </th>
        <th
          class="text-zt-xs py-3 border-b-2 border-t-2 border-zt-dark-100 text-left text-xs text-zt-dark-300 font-normal tracking-wide"
        ></th>
      </tr>
    </thead>
    <tbody class="max-h-full">
      <tr
        class="group"
        v-for="document in content"
        :key="document.documentId"
        @click="setDetailDocument(document.documentId)"
      >
        <td class="pl-4 border-b border-gray-200">
          <zt-check-box
            :value="document.documentId.toString()"
            v-model="arrDocuments"
            data-vs-check-box="document-selected"
            @change="setDocumentSelected"
            @click.stop
            class="zt-custom-checkbox"
            v-if="isActionAllowed(downloadActionId)"
          />
        </td>
        <td class="pr-3 border-b border-gray-200">
          <div
            class="text-zt-xl"
            :class="
              document.type === 'pdf' ? 'text-zt-danger' : 'text-zt-primary-200'
            "
          >
            <zt-icon :name="document.type === 'pdf' ? 'file-pdf' : 'file'" />
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md font-bold text-zt-dark-500">
              {{ document.employee || $t('message.searchComponent.noUser') }}
            </p>
            <span class="text-zt-xs font-normal text-zt-dark-500">{{ document.fiscalId }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md font-normal text-zt-dark-500">{{ document.name }}</p>
            <span class="text-zt-xs font-normal text-zt-dark-500">{{ document.period }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex flex-col">
            <p class="text-zt-md font-normal text-zt-dark-500">{{ document.sector || '-' }}</p>
            <span class="text-zt-xs font-normal text-zt-dark-500">{{ document.location || '-' }}</span>
          </div>
        </td>
        <td class="py-2 border-b border-gray-200 text-sm">
          <div class="flex items-center">
            <div
              class="h-2 w-2 rounded-full mr-2 font-normal text-zt-dark-500"
              :class="getColorByStatus(document.signStatus)"
            />
            <p>
              <span class="font-normal text-zt-dark-500">{{ setUpperCase(document.signStatus.toLowerCase()) }}</span>
            </p>
          </div>
        </td>
        <td
          class="text-center px-4 border-b border-gray-200 group-item text-white"
        >
          <button
            data-vs-button="stop-action"
            style="color: #4f41a3 !important"
            class="focus:outline-none text-zt-xl"
            v-if="document.hasPreview"
            @click.stop="action(document)"
          >
            <zt-icon name="eye" />
          </button>
          <zt-tooltip v-else :text="$t('message.searchComponent.noDoc')" position="top">
            <zt-icon class="text-zt-xl" name="eye-slash" />
          </zt-tooltip>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { forEach } from 'lodash'
import { mapGetters } from 'vuex'

const statusColors = {
  'firmado conforme': 'bg-zt-success',
  'no firmado': 'bg-zt-warning',
  'firmado disconforme': 'bg-zt-danger',
  'no requiere firma': 'bg-zt-dark-400',
  anulado: 'bg-zt-danger',
  rechazado: 'bg-zt-danger',
  'pendiente aprobacion': 'bg-zt-warning',
}

export default {
  name: 'CustomTable',
  props: {
    content: {
      type: Array,
    },
    action: {
      type: Function,
    },
  },
  data() {
    return {
      arrDocuments: [],
      downloadActionId: 29
    }
  },
  methods: {
    getColorByStatus(status) {
      return statusColors[status.toLowerCase()]
    },
    setDocumentSelected() {
      this.$emit('documents-selected', this.arrDocuments)
    },
    setDetailDocument(documentId) {
      const idApp = this.getUser.aplicacion.id
      const isDocumentDetail = this.isActionAllowed(309)
      if (isDocumentDetail) {
        this.$router.push({
          name: 'document-detail',
          params: {
            id: documentId
          },
        })
        return
      }
      window.location = `${window.location.origin}/detalle.documento?id=${documentId}&idaplicacion=${idApp}`
    },
  },
  computed: {
    setUpperCase() {
      return (status) => `${status[0].toUpperCase()}${status.slice(1)}`
    },
    allSelected: {
      set(val) {
        this.arrDocuments = []

        if (val) {
          forEach(this.content, (document) =>
            this.arrDocuments.push(document.documentId.toString())
          )
        }
      },
      get() {
        return this.arrDocuments.length === this.content.length
      },
    },
    ...mapGetters(['isActionAllowed', 'getUser']),
  },
}
</script>
<style lang="scss" scoped>
  .group:hover .group-item {
    color: #4f41a3;
  }
  table {
    position: relative;
    th {
      position: sticky;
      top: 0;
      background: white;
      z-index: 1 !important;
    }
    tbody{
      td{
        cursor: pointer;
      }
      tr{
        &:hover{
          background: #F6F6F6;
        }
      }
    }
  }
  ::v-deep {
    .zt-custom-checkbox {
      .zt-checkbox-slot {
        flex-direction: column!important;
      }
    }
  }
</style>
